/**
 * Фирменный знак компании — исходный логотип из public/logo.png.
 * Размер задаётся в пикселях, пропорции сохраняются.
 */
function BrandMark({ size = 32, className = '' }) {
  return (
    <img
      className={className}
      src={`${process.env.PUBLIC_URL}/logo.png`}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      decoding="async"
    />
  );
}

export default BrandMark;
